import React, { useState } from 'react';
import { 
  CheckCircle2, 
  Home, 
  Star, 
  GraduationCap, 
  Briefcase, 
  Sparkles, 
  Calendar, 
  Wifi, 
  Car, 
  Mountain, 
  UtensilsCrossed 
} from 'lucide-react';
import { Link } from 'react-router-dom';

// 1. IMPORTACIÓN DE TUS IMÁGENES LOCALES
import imgFachada from '../assets/fachada-graciosenea.webp';
import imgCocina from '../assets/cocina-Graciosenea.webp';
import imgDormitorioDoble from '../assets/dormitorio-doble.webp';
import imgDormitorioMatrimonio from '../assets/dormitorio-matrimonio.webp';
import imgBodega from '../assets/bodega-botellas-cubas.webp';
import imgSalaCuadros from '../assets/sala-cuadros.webp';
import imgBaño from '../assets/sala-de-bano-adaptado.webp';
import imgPianoCoworking from '../assets/sala-piano-chimenea-coworking.webp';
import imgSillas from '../assets/sillas-sala-principal.webp';
import imgVestidor from '../assets/vestidor-espejo-vintage.webp';

const LaCasa = () => {
  const [activeImage, setActiveImage] = useState(0);

  const galleryImages = [
    { url: imgFachada, alt: 'Fachada Graciosenea' },
    { url: imgSalaCuadros, alt: 'Segunda sala' },
    { url: imgPianoCoworking, alt: 'Sala de estar y coworking' },
    { url: imgCocina, alt: 'Cocina equipada' },
    { url: imgDormitorioDoble, alt: 'Dormitorio Doble' },
    { url: imgDormitorioMatrimonio, alt: 'Dormitorio Principal' },
    { url: imgBaño, alt: 'Baño adaptado grande' },
    { url: imgVestidor, alt: 'Vestidor vintage' },
    { url: imgBodega, alt: 'Bodega histórica' },
    { url: imgSillas, alt: 'Zona de comedor' }
  ];

  const features = [
    {
      icon: <Mountain size={32} />,
      title: 'Exteriores',
      items: ['Terraza de 60m²', 'Jardín con huerto', 'Zona de aparcamiento', 'Vistas a la montaña', 'Junto al río con posibilidad de baño', 'Cerca de Francia y playa (30 km)'],
    },
    {
      icon: <Home size={32} />,
      title: 'Zonas Comunes',
      items: ['Salón con chimenea y piano', 'Decoración original siglo XIX', 'Uso de cocina', 'Txoko', '2 baños grandes', 'Cocina industrial equipada'],
    },
    {
      icon: <Sparkles size={32} />,
      title: 'Habitaciones',
      items: ['Cama', 'Armario', 'Mesa y silla', 'Ropa de cama', 'Toallas'],
    },
    {
      icon: <Wifi size={32} />,
      title: 'Servicios',
      items: ['Desayuno incluido', 'WiFi gratuito', 'Mascotas aceptadas (consultar)', 'Leña gratis', 'Juegos de mesa', 'Palas y raquetas'],
    },
  ];

  return (
    <div className="min-h-screen pt-20" style={{ backgroundColor: 'var(--color-cream)' }}>
      {/* Hero */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img src={imgFachada} alt="Graciosenea" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/50" />
        </div>
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-5xl md:text-6xl font-bold mb-4 text-[#FDFFD2]" style={{ fontFamily: "'Playfair Display', serif" }}>La Casa</h1>
          <p className="text-xl md:text-2xl">Graciosenea, una casa rural de principios del siglo XX</p>
        </div>
      </section>

      {/* Gallery */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold mb-12 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>Galería</h2>
          <div className="max-w-6xl mx-auto">
            <div className="mb-6 rounded-lg overflow-hidden shadow-xl">
              <img src={galleryImages[activeImage].url} alt={galleryImages[activeImage].alt} className="w-full h-[500px] object-cover" />
            </div>
            <div className="grid grid-cols-3 md:grid-cols-6 gap-4">
              {galleryImages.map((image, index) => (
                <button 
                  key={index} 
                  onClick={() => setActiveImage(index)} 
                  className={`rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all ${activeImage === index ? 'ring-4 ring-[#9B2C2C]' : ''}`}
                >
                  <img src={image.url} alt={image.alt} className="w-full h-24 object-cover" />
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold mb-12 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>Las gracias en una construcción única</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-[#F5F2ED] rounded-lg p-6">
                <div className="text-[#9B2C2C] mb-4">{feature.icon}</div>
                <h3 className="text-xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>{feature.title}</h3>
                <ul className="space-y-2">
                  {feature.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 bg-[#9B2C2C] rounded-full mt-2 flex-shrink-0" />
                      <span className="text-[#5A5F4D]">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TARIFAS SECTION */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold mb-12 text-center" style={{ fontFamily: "'Playfair Display', serif", color: '#2D3319' }}>Planes y Tarifas</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
            
            {/* 1. CASA COMPLETA */}
            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 flex flex-col transition-all hover:shadow-2xl">
              <div className="p-6 flex-grow">
                <div className="flex justify-between items-start mb-4">
                  <Home className="text-[#9B2C2C]" size={28} />
                  <span className="text-[#9B2C2C] font-bold text-[10px] tracking-widest uppercase">Hasta 11 personas</span>
                </div>
                <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif", color: '#2D3319' }}>Casa Completa</h3>
                <div className="flex items-baseline gap-1 mb-4">
                  <span className="text-3xl font-bold text-[#9B2C2C]">275€</span>
                  <span className="text-sm text-[#5A5F4D]">/noche</span>
                </div>
                <p className="text-xs text-gray-600 mb-6 leading-relaxed">
                  Disfruta de la casa en exclusividad. Ideal para familias o grupos que buscan intimidad total en un entorno histórico.
                </p>
                <ul className="space-y-3 text-sm">
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Uso exclusivo total</li>
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Cocina histórica equipada</li>
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Desayuno casero incluido</li>
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Acceso a jardín y salones</li>
                </ul>
              </div>
              <div className="p-6 pt-0 mt-auto">
                <Link to="/contacto" className="block text-center py-3 bg-[#9B2C2C] text-white rounded-xl font-bold text-sm hover:bg-[#7d2323] transition-all">Reservar casa</Link>
              </div>
            </div>

            {/* 2. HABITACIÓN DOBLE */}
            <div className="bg-white rounded-2xl shadow-xl border-2 border-[#8B9A8E]/20 flex flex-col transition-all hover:shadow-2xl">
              <div className="p-6 flex-grow">
                <div className="flex justify-between items-start mb-4">
                  <Star className="text-[#8B9A8E]" size={28} />
                  <span className="text-[#8B9A8E] font-bold text-[10px] tracking-widest uppercase">Por habitación</span>
                </div>
                <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif", color: '#2D3319' }}>Habitación Doble</h3>
                <div className="flex items-baseline gap-1 mb-4">
                  <span className="text-3xl font-bold text-[#2D3319]">70€</span>
                  <span className="text-sm text-[#5A5F4D]">/noche</span>
                </div>
                <ul className="space-y-3 text-sm mb-6">
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#8B9A8E] mt-1 flex-shrink-0" /> Mobiliario y suelos de época</li>
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#8B9A8E] mt-1 flex-shrink-0" /> Desayuno incluido</li>
                  <li className="flex items-start gap-2 text-[#2D3319] italic"><CheckCircle2 size={16} className="text-[#8B9A8E] mt-1 flex-shrink-0" /> Cama supletoria 20€ (máx. 2)</li>
                </ul>
                <div className="bg-[#F5F2ED] rounded-xl p-3 border border-[#8B9A8E]/30 text-center">
                  <p className="text-[11px] font-bold text-[#2D3319] uppercase mb-1">¿Sois más de 5?</p>
                  <p className="text-[#9B2C2C] font-bold text-sm">Solo 25€/persona</p>
                  <p className="text-[10px] text-gray-500">en habitación doble</p>
                </div>
              </div>
              <div className="p-6 pt-0 mt-auto">
                <Link to="/contacto" className="block text-center py-3 border-2 border-[#2D3319] text-[#2D3319] rounded-xl font-bold text-sm hover:bg-[#2D3319] hover:text-white transition-all">Reservar ahora</Link>
              </div>
            </div>

            {/* 3. APRENDIZAJE */}
            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 flex flex-col transition-all hover:shadow-2xl">
              <div className="p-6 flex-grow">
                <div className="flex justify-between items-start mb-4">
                  <GraduationCap className="text-[#9B2C2C]" size={28} />
                  <span className="text-[#9B2C2C] font-bold text-[10px] tracking-widest uppercase">Experiencia Vital</span>
                </div>
                <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif", color: '#2D3319' }}>Aprendizaje</h3>
                <div className="flex items-baseline gap-1 mb-4">
                  <span className="text-3xl font-bold text-[#9B2C2C]">40€</span>
                  <span className="text-sm text-[#5A5F4D]">/noche</span>
                </div>
                <p className="text-xs text-gray-600 mb-6 leading-relaxed">
                  Una inmersión en la vida rural. Participa, aprende y convive mientras disfrutas de una estancia con sentido.
                </p>
                <ul className="space-y-3 text-sm">
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Pensión completa</li>
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Talleres y actividades</li>
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Cocina colaborativa</li>
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Espacios compartidos</li>
                </ul>
              </div>
              <div className="p-6 pt-0 mt-auto">
                <Link to="/aprendizaje-colaborativo" className="block text-center py-3 bg-[#8B9A8E] text-white rounded-xl font-bold text-sm hover:bg-[#6e7a70] transition-all">Saber más</Link>
              </div>
            </div>

            {/* 4. PROFESIONALES */}
            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 flex flex-col transition-all hover:shadow-2xl">
              <div className="p-6 flex-grow">
                <div className="flex justify-between items-start mb-4">
                  <Briefcase className="text-[#9B2C2C]" size={28} />
                  <span className="text-[#9B2C2C] font-bold text-[10px] tracking-widest uppercase">Coworking & Retiros</span>
                </div>
                <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif", color: '#2D3319' }}>Profesionales</h3>
                <div className="mt-2 mb-4">
                  <span className="text-2xl font-bold text-[#2D3319] uppercase">Consultar</span>
                </div>
                <p className="text-xs text-gray-600 mb-6 leading-relaxed">
                  El lugar perfecto para desconectar del ruido y conectar con el equipo o con tu propia creatividad.
                </p>
                <ul className="space-y-3 text-sm">
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Espacios de coworking</li>
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Eventos y rodajes</li>
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Conexión alta velocidad</li>
                  <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Catering bajo petición</li>
                </ul>
              </div>
              <div className="p-6 pt-0 mt-auto">
                <Link to="/profesionales" className="block text-center py-3 border-2 border-[#8B9A8E] text-[#8B9A8E] rounded-xl font-bold text-sm hover:bg-[#8B9A8E] hover:text-white transition-all">Ver opciones</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#9B2C2C] text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" style={{ fontFamily: "'Playfair Display', serif" }}>Reserva sin comisiones</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto text-white/90">Contacto directo, mejor precio garantizado, resolución instantánea de consultas.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/contacto" className="inline-block px-8 py-4 bg-white text-[#9B2C2C] rounded hover:bg-gray-100 transition-all">Solicita tu estancia</Link>
            <a href="tel:623151160" className="inline-block px-8 py-4 border-2 border-white text-white rounded hover:bg-white hover:text-[#9B2C2C] transition-all">623 15 11 60</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LaCasa;